import React from "react";
import { _t } from "app/i18n/i18n";
import useFetchEmailForecast from "lib/hooks/useFetchEmailForecast/useFetchEmailForecast";
import { useCreateSubscriptionsRequestBody } from "components/Subscriptions/SubscriptionsModal/SubscriptionsModal.helpers";
import { LoadingSpinner } from "lib/Spinner";
import styles from "./SubscriptionsForecastChart.module.scss";
import { getIdToName } from "./SubscriptionsForecastChart.helpers";

function SubscriptionsForecastChart({
  selectedSubscriptionTags,
  selectedLanguages,
  selectedPub,
  isSubscriptionFromPillsBar,
}) {
  const requestBody = useCreateSubscriptionsRequestBody(
    selectedSubscriptionTags,
    selectedLanguages,
    selectedPub,
    isSubscriptionFromPillsBar,
  );
  const [data, isLoading, isError] = useFetchEmailForecast(requestBody);
  const { dateRange } = data?.data || {};

  if (isLoading) return <LoadingSpinner className="mx-auto pt-5 pb-5" />;

  const hasData = Array.isArray(dateRange) && dateRange.length > 0;

  return (
    <div className={styles.wrapper}>
      {!hasData || isError ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyTitle}>{_t("No forecast data available")}</div>
        </div>
      ) : (
        <div className={styles.chartWrapper} aria-label="Email forecast by time range">
          {dateRange.map(({ id, count }) => {
            const label = getIdToName(id);
            const numericCount = Number(count || 0);

            return (
              <div key={id} className={styles.row}>
                <div className={styles.label} title={label}>
                  {label}
                </div>

                <div className={styles.separator} aria-hidden="true">
                  |
                </div>

                <div className={styles.value} title={`${numericCount}`}>
                  {numericCount}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SubscriptionsForecastChart;
